import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import TopNavBar from '../Layout/TopNavBar';
import BackNavigation from '../Common/BackNavigation';
import { useLocation, useNavigate } from 'react-router-dom';
import upload from "../../assets/upload.svg";
import { showError, showSuccess } from '../utills/sweetAlert';
import { callApi } from '../utills/api';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Hourglass } from 'react-loader-spinner';

const AddBlog: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { masterId } = location.state || {};
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        title: "",
        id: "",
        imageTitle: "",
        image: "",
        description: "",
    });

    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [attachments, setAttachments] = useState([
        {
            deleteStatus: false,
            imageType: "",
            imageData: "",
            updateStatus: false,
        },
    ]);
    const [imageError, setImageError] = useState("");
    const [descError, setDescError] = useState("");

    const siteOnchange = (event: any) => {
        const { name, value } = event.target;
        const sanitizedValue = value.replace(/ {2,}/g, ' ');

        setState((prevState) => ({
            ...prevState,
            [name]: sanitizedValue,
        }));
    }

    const handleEditorChange = (event: any, editor: any) => {
        const data = editor.getData();
        setState((prevState) => ({
            ...prevState,
            description: data,
        }));
        setDescError("");
    };

    const [showImage, setShowImage] = useState(false);
    const handleImageClose = () => {
        setShowImage(false);
    };

    const validateFile = (file: any) => {
        const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        if (!validTypes.includes(file.type)) {
            return "Unsupported file format. Please upload JPEG, PNG, or SVG.";
        }
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {

            convertFileToBase64(file);
            setErrorMessage("");
            URL.revokeObjectURL(img.src);
        };
        return null;
    };

    const convertFileToBase64 = (file: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64data = reader.result as string;
            const imageType = file.type.split("/")[1];
            setAttachments((prevAttachments) => [
                ...prevAttachments.slice(0, prevAttachments.length - 1),
                {
                    ...prevAttachments[prevAttachments.length - 1],
                    imageData: base64data,
                    imageType: imageType,
                    updateStatus: true,
                },
            ]);
            setImageError("");
            setSuccessMessage("File uploaded successfully!");
        };
        reader.onerror = () => {
            setErrorMessage("Error converting file to Base64.");
        };
    };

    const handleFileChange = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setSuccessMessage("");
            const error = validateFile(file);
            if (error) {
                setErrorMessage(error);
            }
        }
    };

    const handleDrop = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        if (file) {
            setSuccessMessage("");
            const error = validateFile(file);
            if (error) {
                setErrorMessage(error);
            }
        }
    };

    const handleDragOver = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
    };

    useEffect(() => {
        if (masterId) {
            handleEdit(masterId)
        }
    }, []);
    const handleEdit = (id: any) => {
        let req = {
            id: id,
        };
        callApi("POST", "blogSingleSelect.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response-->", response.data[0].id);
                    setState((prevState) => ({
                        ...prevState,
                        id: response.data[0].id,
                        title: response.data[0].title,
                        imageTitle: response.data[0].imageTitle,
                        description: response.data[0].description,
                        image: response.data[0].image,
                    }));
                    setShowImage(true);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const handleSubmit = (event: any) => {
        const form = event.target.form;
        if (form.checkValidity() === false) {
            console.log("Form validation failed.");
            return;
        }
        event.preventDefault();
        if (attachments[0].imageData == "") {
            console.log("not coming");
            event.preventDefault();
            setImageError("Upload Image Required.");
        } else if (state.description == "") {
            setDescError("Description Required")
        } else {
            const trimmedtitle = state.title.trim();
            const trimmedimageTitle = state.imageTitle.trim();
            if (trimmedtitle && trimmedimageTitle) {
                let request = {
                    title: trimmedtitle,
                    imageTitle: trimmedimageTitle,
                    description: state.description,
                    attachment: attachments
                }
                setLoading(true);
                callApi("POST", "blogInsert.php", request)
                    .then((res) => res.data)
                    .then((response) => {
                        if (response) {
                            setLoading(false);
                            showSuccess("Success!", "Blog Created Successfully!");
                            setState((prevState) => ({
                                ...prevState,
                                title: "",
                                description: "",
                                imageTitle: "",
                                id: ""
                            }));
                            setAttachments((prevAttachments: any) => [
                                ...prevAttachments.slice(0, prevAttachments.length - 1), // Remove the last element
                                {
                                    ...prevAttachments[prevAttachments.length - 1],
                                    imageData: "", // Set the base64 data
                                    imageType: "",
                                    updateStatus: "",
                                },
                            ]);
                            setImageError("");
                            setDescError("");
                            setErrorMessage("");
                            setSuccessMessage("");
                            navigate('/layout/Blog');
                        }
                    })
                    .catch((err: any) => {
                        console.error(
                            "API call error:",
                            err.response ? err.response.data.error : err.message
                        );
                        showError(
                            "Failed",
                            err.response ? err.response.data.error : err.message
                        );
                    });
            } else {
                showError(
                    "Failed", "Empty Space Not Allowed");
            }
        }
    }

    const handleUpdate = (event: any) => {
        const form = event.target.form;
        event.preventDefault();
        const trimmedtitle = state.title.trim();
        const trimmedimageTitle = state.imageTitle.trim();
        if (trimmedtitle && trimmedimageTitle) {
            let request = {
                blogId: state.id,
                title: trimmedtitle,
                imageTitle: trimmedimageTitle,
                description: state.description,
                attachment: attachments
            }
            setLoading(true);
            callApi("POST", "blogUpdate.php", request)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        setLoading(false);
                        showSuccess("Success!", "Blog Updated Successfully!");
                        setState((prevState) => ({
                            ...prevState,
                            title: "",
                            description: "",
                            imageTitle: "",
                            id: "",
                            image: "",
                        }));
                        navigate('/layout/Blog');
                        setErrorMessage("");
                        setSuccessMessage("");
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }

    return (
        <>
            <div className="mobile_nav_bar">
                <TopNavBar />
            </div>
            <div className='mblcontent'>
                <form>
                    <Row className='webview'>
                        <div className="category-header">
                            <Col lg="9" md="9">
                                <BackNavigation />
                                <h3 className="category-title mt-2">
                                    {masterId ? "Edit Blog" : "Add Blog"}
                                </h3>
                            </Col>
                        </div>
                    </Row>
                    <div className="element-container">
                        <Row>
                            <Col md="3" className="flexalignitemcenter mt-4 mb-4">
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Title"
                                    name="title"
                                    minLength={2}
                                    onChange={siteOnchange}
                                    value={state.title}
                                    pattern="^[A-Za-z0-9@#$_%&-]+( [A-Za-z0-9@#$_%&-]+)*$"
                                    maxLength={500}
                                    required />
                            </Col>
                            <Col md="3" className="flexalignitemcenter mt-4 mb-4">
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Image Title"
                                    name="imageTitle"
                                    minLength={2}
                                    onChange={siteOnchange}
                                    value={state.imageTitle}
                                    pattern="^[A-Za-z0-9@#$_%&-]+( [A-Za-z0-9@#$_%&-]+)*$"
                                    maxLength={500}
                                    required />
                            </Col>
                            <Col md="5" className="flexalignitemcenter mt-4 mb-4">
                                {!showImage && (
                                    <div
                                        className="file-upload"
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <input
                                            type="file"
                                            id="file-input"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                        />
                                        <div
                                            className="upload-icon"
                                            onClick={() => {
                                                const fileInput =
                                                    document.getElementById("file-input");
                                                if (fileInput) {
                                                    fileInput.click();
                                                } else {
                                                    console.error("File input not found");
                                                }
                                            }}
                                        >
                                            <img src={upload} alt="Upload Icon" />
                                        </div>
                                        <div className="drag-drop-area">
                                            <p>
                                                Drag and Drop file here or{" "}
                                                <label
                                                    htmlFor="file-input"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Choose file
                                                </label>
                                            </p>
                                            <p className="file-info">
                                                Supported formats: JPEG, PNG, SVG
                                            </p>
                      <p style={{color:"red"}}>Minimum upload size (484px X 530px)</p>

                                            {errorMessage && (
                                                <div className="error-message">{errorMessage}</div>
                                            )}
                                            {successMessage && (
                                                <div className="success-message">
                                                    {successMessage}
                                                </div>
                                            )}
                                            {imageError && (
                                                <div className="error-message" style={{ color: "red" }}>
                                                    {imageError}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {state.image &&
                                    showImage && ( // Show the image if available and visible
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                            }}
                                        >
                                            <img
                                                src={state.image}
                                                alt="Uploaded Icon"
                                                style={{ width: "100px" }}
                                            />
                                            <span
                                                className='removeimg'
                                                onClick={handleImageClose}
                                            >
                                                &times;
                                            </span>
                                        </div>
                                    )}
                            </Col>
                            <Col md="12" >
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={state.description}
                                    onChange={handleEditorChange}
                                    config={{
                                        toolbar: [
                                            "heading",
                                            "|",
                                            "clipboard",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strikethrough",
                                            "|",
                                            "bulletedList",
                                            "numberedList",
                                            "|",
                                            "undo",
                                            "redo",
                                        ],
                                    }}
                                />
                                 {descError && (
                                                <div className="error-message" style={{ color: "red" }}>
                                                    {descError}
                                                </div>
                                            )}
                            </Col>

                            <Col md="3">
                                <div className="savenew">
                                    {state.id ? (
                                        <>
                                            <button
                                                className="btn btn-primary modalsubbutton mt-3 mb-3"
                                                type="button"
                                                onClick={handleUpdate}
                                            >
                                                Update
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            className="btn btn-primary modalsubbutton mt-3 mb-3"
                                            type="submit"
                                            onClick={handleSubmit}
                                        >
                                            Save
                                        </button>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </form>
            </div>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader-container">
                        <Hourglass visible={true} height={50} width={50} />
                    </div>
                </div>
            )}
        </>
    );
};
export default AddBlog;


